import LegalPage, { type BusinessIdentity } from '@/components/LegalPage'

/** Delivery conditions live beside the other translated customer documents. */
export default function Delivery({ business }: { business: BusinessIdentity }) {
  return <LegalPage page="delivery" business={business} />
}
